import { ColumnType } from '~shared/rundown/column'
import type { Column } from '~shared/rundown/column'

/**
 * DOM id of a column's name, which labels its `columnheader`.
 */
export function getColumnNameDomId(columnId: Column['id']): string {
  return `column-name-${columnId}`
}

/** The types a column can be converted to. */
export type ColumnConversionTarget =
  | typeof ColumnType.RICHTEXT
  | typeof ColumnType.SELECT

/** Display name of each conversion target. */
export const COLUMN_TYPE_LABELS: Record<ColumnConversionTarget, string> = {
  [ColumnType.RICHTEXT]: 'Richtext',
  [ColumnType.SELECT]: 'Dropdown',
}

/** One-line explanation of how each conversion target works. */
export const COLUMN_TYPE_DESCRIPTIONS: Record<ColumnConversionTarget, string> =
  {
    [ColumnType.RICHTEXT]:
      'Richtext columns let you add formatted text, links, images and files in each cell.',
    [ColumnType.SELECT]:
      'Dropdown columns let you pick one value per cell from a list of options.',
  }
